{
  "it": {
    "validation_error": {
      "fleet_memberships": {
        "create": "Membro già presente o ha un invito in sospeso"
      }
    }
  }
}
